import { nanoid } from '@reduxjs/toolkit'
import { put, takeLatest } from 'redux-saga/effects'

import { NotificationManager } from '@/components/Notification'
import { machineService } from '@/services'
import {
  getMachinesList,
  getMachinesListFailed,
  getMachinesListSucceeded,
  searchMachinesList,
  searchMachinesListFailed,
  searchMachinesListSucceeded,
} from '@/store/slices/machineSlice'
import { isValidArray } from '@/libs/utils/array'

function generateItemKeys(items) {
  if (isValidArray(items)) {
    return items.map((item) => ({
      ...item,
      key: nanoid(),
    }))
  }

  return []
}

function* getMachinesListSaga({ payload }) {
  try {
    const { data } = yield machineService.getMachinesList(payload)
    const { items } = data

    const transformedItems = generateItemKeys(items)
    const transformedData = {
      ...data,
      items: transformedItems,
    }

    yield put(getMachinesListSucceeded(transformedData))
  } catch (error) {
    yield put(getMachinesListFailed())
    console.error('error when retriving machines list:', error)
    NotificationManager.error({
      message: 'notification.error.load',
    })
  }
}

function* searchMachinesListSaga({ payload }) {
  try {
    const { data } = yield machineService.searchMachinesList(payload)
    const { items } = data
    const transformedItems = generateItemKeys(items)
    const transformedData = {
      ...data,
      items: transformedItems,
    }

    yield put(searchMachinesListSucceeded(transformedData))
  } catch (error) {
    console.error('Error when searching machines list:', error)
    yield put(searchMachinesListFailed())
  }
}

function* machineSaga() {
  yield takeLatest(getMachinesList.type.toString(), getMachinesListSaga)
  yield takeLatest(searchMachinesList.type.toString(), searchMachinesListSaga)
}

export default machineSaga
